<template>
	<div v-if="showName" class="row mb-2">
		<h5 class="bg-info p-2">
			{{
				name.includes("Lead")
					? name.replace(/([a-z0-9])([A-Z])/g, "$1 $2").replace("Lead", "")
					: name.replace(/([a-z0-9])([A-Z])/g, "$1 $2")
			}}
		</h5>
	</div>
	<component
		:is="optionComponent"
		v-for="(component, index) in data.count"
		:key="`${index}-component`"
		:count="index"
		:id="index + 1"
		:defaultData="
			(masterStore.state.activeComponent === 'edit' && data.data.length) ||
			(stateKey === 'payments' && parentState[stateKey].length)
				? data.data[index]
				: ''
		"
		@updateData="updateData"
		@removeComponent="removeComponent"
	/>
	<div class="col-sm-4 cursor-pointer">
		<a
			class="cursor-pointer btn btn-sm text-danger"
			@click.stop="addComponent()"
			><i class="bi bi-plus-circle"></i>Add More</a
		>
	</div>
</template>
<script>
	import { defineAsyncComponent, reactive, inject } from "vue";
	export default {
		name: "DynamicMultiplier",
		props: {
			name: {
				type: String,
			},
			stateKey: {
				type: String,
				required: true,
				default: "visa",
			},
			state: {
				type: String,
				default: "leadState",
			},
			showName: {
				type: Boolean,
				default: true,
			},
			countArr: {
				type: [Array, Boolean],
				default: false,
			},
		},
		computed: {
			optionComponent() {
				return defineAsyncComponent(() => {
					return import(`@/components/${this.name}.vue`);
				});
			},
		},

		setup: (props) => {
			const masterStore = inject("masterStore");
			const parentState = inject(props.state);

			const data = reactive({
				count: [1],
				data: [],
				countSet: false,
			});

			if (props?.countArr.length) {
				data.count = [...props.countArr];

				data.data = [...parentState[props.stateKey]];
				data.countSet = true;
			}

			const addComponent = () => {
				data.count.push(1);
			};

			const removeComponent = (index) => {
				data.data = data.data.filter(
					(dataItem, dataIndex) => dataIndex !== index,
				);
				data.count.pop();
				if (props.state === "leadState")
					parentState.state.data[props.stateKey] = data.data;
				else parentState[props.stateKey] = data.data;
			};

			const updateData = (payload) => {
				if (payload.index instanceof Number) return;
				if (!Object.keys(payload.data).length) return;
				data.data[payload.index] = { ...payload.data };
				if (props.state === "leadState")
					parentState.state.data[props.stateKey] = data.data;
				else parentState[props.stateKey] = data.data;
			};

			const setEditData = () => {
				if (
					props.state === "leadState" &&
					parentState.state.data[props.stateKey] instanceof Array
				) {
					if (!parentState.state.data[props.stateKey].length) return;
					let countArr = [];
					parentState.state.data[props.stateKey].map((stateData) => {
						countArr.push(1);
						let newStateData = { ...stateData };
						delete newStateData._id;
						data.data = [...data.data, { ...newStateData }];
					});
					data.count = countArr;
					data.countSet = true;
				}
			};

			if (masterStore.state.activeComponent === "edit") {
				setEditData();
			}

			if (props.stateKey === "payments" && parentState[props.stateKey].length) {
				if (!parentState[props.stateKey].length) return;
				let countArr = [];
				parentState[props.stateKey].map((stateData) => {
					countArr.push(1);
					let newStateData = { ...stateData };
					delete newStateData._id;
					data.data = [...data.data, { ...newStateData }];
				});
				data.count = countArr;
				data.countSet = true;

				data.data = parentState[props.stateKey];
			}

			return {
				data,
				parentState,
				masterStore,
				addComponent,
				removeComponent,
				updateData,
			};
		},
	};
</script>
